import { IconButton } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { type RootState, useAppDispatch } from 'store';
import { goBack } from 'store/navigation';

const BackButton = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const history = useSelector((state: RootState) => state.navigation.history);

  const pathName = location.pathname;
  const previousPath = (location.state as { from?: string } | null)?.from;

  if (pathName === '/') {
    return <></>;
  }

  const handleClick = (): void => {
    if (previousPath) {
      navigate(previousPath, { replace: true });
      return;
    }

    if (history.length > 1) {
      dispatch(goBack());
      navigate(history[history.length - 2]);
    }
  };

  return (
    <IconButton onClick={handleClick}>
      <KeyboardBackspaceIcon />
    </IconButton>
  );
};

export default BackButton;
